import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSidenavModule } from "@angular/material/sidenav";
import { RouterModule } from "@angular/router";
import { FuseConfirmDialogModule, FuseWidgetModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { ComponentsModule } from "app/components/components.module";
import { AuthGuard } from "app/guards/auth.guard";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { AlarmsComponent } from "./components/alarms/alarms.component";
import { ConnectedDevicesComponent } from "./components/connected-devices/connected-devices.component";
import { EventStreamComponent } from "./components/event-stream/event-stream.component";
import { DashboardSidebarComponent } from "./dashboard-sidebar/dashboard-sidebar.component";
import { DashboardComponent } from "./dashboard.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { Gridster, GridsterItem } from "angular-gridster2";
import { CustomWidgetEditorComponent } from "./custom-widget-editor/custom-widget-editor.component";

const routes = [
    {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard],
    },
];

@NgModule({
    declarations: [
        DashboardComponent,
        ConnectedDevicesComponent,
        EventStreamComponent,
        AlarmsComponent,
        ConnectedDevicesComponent,
        DashboardSidebarComponent,
        CustomWidgetEditorComponent,
        TimeAgoPipe,
    ],
    imports: [
        RouterModule.forChild(routes),
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSidenavModule,
        MatListModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        TranslateModule,
        FuseConfirmDialogModule,
        FuseSharedModule,
        FuseWidgetModule,
        Gridster,
        GridsterItem,
        ComponentsModule,
    ],
    exports: [DashboardComponent],
})
export class DashboardModule {}
